import React from 'react';
import { useApp } from '../../context/AppContext';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import SectionTitle from '../ui/SectionTitle';
import QRCode from '../ui/QRCode';
import './Contact.css';

interface Props {
  contactCTA: { es: string; en: string };
}

const Contact: React.FC<Props> = ({ contactCTA }) => {
  const { t, lang } = useApp();
  const ref = useScrollReveal();

  return (
    <section className="contact" id="contacto">
      <div
        className="contact__inner reveal-section"
        ref={ref as React.RefObject<HTMLDivElement>}
      >
        <SectionTitle
          eyebrow={lang === 'es' ? 'Hablemos' : "Let's connect"}
          title={t(contactCTA)}
          light
          number="05"
        />

        <div className="contact__grid">
          {/* Column 1: direct contact */}
          <div className="contact__info">
            <a href="mailto:dluquin@gmail.com" className="contact__item">
              <span className="contact__item-icon">✉</span>
              <span>dluquin@gmail.com</span>
            </a>
            <a href="tel:+34646483334" className="contact__item">
              <span className="contact__item-icon">✆</span>
              <span>+34 646 483 334</span>
            </a>
            <a
              href="https://www.linkedin.com/in/davidluquin"
              target="_blank"
              rel="noopener noreferrer"
              className="contact__item"
            >
              <span className="contact__item-icon">in</span>
              <span>linkedin.com/in/davidluquin</span>
            </a>
            <div className="contact__item contact__item--text">
              <span className="contact__item-icon">⊙</span>
              <span>Madrid · Pamplona</span>
            </div>
          </div>

          {/* Column 2: QR + GPT */}
          <div className="contact__gpt">
            <QRCode />
          </div>

          {/* Column 3: availability */}
          <div className="contact__avail">
            <h3 className="contact__avail-title">
              {lang === 'es' ? 'Disponibilidad' : 'Availability'}
            </h3>
            <p className="contact__avail-text">
              {lang === 'es'
                ? 'Abierto a conversaciones sobre nuevos proyectos, posiciones directivas o de Consejo de Administración, y oportunidades de colaboración estratégica.'
                : 'Open to conversations about new projects, executive or board positions, and strategic collaboration opportunities.'}
            </p>
          </div>
        </div>

        <div className="contact__footer">
          <p>© {new Date().getFullYear()} David Luquin Urtasun</p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
